<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Storage'"
            [description]="'Manage your Atoku storage here.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
            <div class="atoku-filter-bar" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-form-field class="custom-text-field atoku-select-field" appearance="outline" floatLabel="always">
                    <mat-label>Pricing Profile</mat-label>
                    <mat-select [(value)]="selectedPricingProfileCode" (selectionChange)="onPricingProfileChange()">
                        <mat-option *ngFor="let profile of pricingProfiles" [value]="profile.code">
                            {{ profile.code }} - {{ profile.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="mat-elevation-z3 radius-10 crud-table-shell" fxLayout="column">
                <app-crud-table
                    [modelType]="crudInventoryModel"
                    [displayColumns]="displayColumns"
                    [tableData]="tableData"
                    [title]="'Storage'"
                    [subTitle]="'Create, edit, and review storage records'"
                    [additionalActions]="additionalActions">
                </app-crud-table>
            </div>
        </div>
    </div>
</div>
